import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Alert,
} from '@mui/material';
import { TenantDateField } from '../../../components/TenantDateField';
import { useTenantStore } from '../../../stores/tenant.store';
import { useAcademic } from '../../../hooks/use-academic';

interface OpenTermDialogProps {
  open: boolean;
  onClose: () => void;
}

export function OpenTermDialog({ open, onClose }: OpenTermDialogProps) {
  const { currentTenantId } = useTenantStore();
  const { createTerm, isCreatingTerm } = useAcademic();

  const [name, setName] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentTenantId) return;

    setError(null);
    try {
      const formatPayloadDate = (dateStr: string) => {
        // Formatos HTML5 type="date" envían YYYY-MM-DD
        // Si el usuario teclea, aseguramos que cumpla el schema
        const d = new Date(dateStr);
        return d.toISOString().split('T')[0]!;
      };

      await createTerm({
        tenantId: currentTenantId,
        name,
        startDate: formatPayloadDate(startDate),
        endDate: formatPayloadDate(endDate),
      });
      onClose();
      setName('');
      setStartDate('');
      setEndDate('');
    } catch (err: any) {
      setError(err.message || 'Error opening term');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Abrir Período (Term)</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            {error && <Alert severity="error">{error}</Alert>}

            <TextField
              label="Nombre del Período"
              required
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              helperText="Ej. Otoño 2025"
            />

            <TenantDateField
              label="Fecha de Inicio"
              value={startDate}
              onChange={setStartDate}
              fullWidth
            />

            <TenantDateField
              label="Fecha de Término"
              value={endDate}
              onChange={setEndDate}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} disabled={isCreatingTerm}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isCreatingTerm}
            sx={{ minWidth: 120 }}
          >
            {isCreatingTerm ? 'Abriendo...' : 'Abrir'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
